import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources =
{
    en:
        {
            translation:
            {
                Start: 'Start the future',
                welcome: 'Hey you, be very Welcome',
                Home: 'Home',
                description: "Welcome to ACME AI — a forward-thinking company specialized in business automation powered by artificial intelligence and the platforms that enhance it. We help small businesses unlock their growth potential with intelligent, scalable, and affordable solutions. Whether optimizing processes, integrating systems, or eliminating repetitive tasks, our expertise transforms complexity into opportunity.",
                Skills: 'What we do',
                SkillsTitle: 'Smart Automation. Strategic Growth.',
                heroDescription: "We help businesses simplify operations, eliminate inefficiencies, and unlock scalable growth through intelligent systems.",
                Projects: 'Projects',
                ProjectsTitle: 'My Projects',
                whyTitle: "Why Choose Us",
                why1: "We focus on business outcomes, not just code.",
                why2: "We build scalable solutions, not temporary fixes.",
                why3: "We combine technical execution with strategic thinking.",
                why4: "We work as partners, not just service providers.",
                resultsTitle: "Results We Deliver",
                result1: "Increased operational efficiency",
                result2: "Reduced process costs",
                result3: "Improved customer experience",
                result4: "Scalable digital infrastructure",
                processTitle: "Our Process",
                process1Title: "Discovery",
                process1Desc: "We understand your business, challenges, and opportunities.",
                process2Title: "Strategy",
                process2Desc: "We design the most effective and scalable solution.",
                process3Title: "Execution",
                process3Desc: "We build, test, and implement.",
                process4Title: "Optimization",
                process4Desc: "We refine and improve continuously.",
                ctaTitle: "Let's Build Together",
                ctaDesc: "Ready to transform your business with smart automation and intelligent systems?",
                ctaButton: "Start a Conversation",
                ProjectsButton: 'View Project',
                Contact: 'Contact',
                Name: 'Name',
                Message: 'Message',
                Send: 'Send',
                MessageSentSuccess: "Message sent successfully!",
                MessageSentFailure: "Error sending message. Try again.",
                PrivacyPolicy: 'Privacy Policy',
                TermsOfUse: 'Terms of Use',
            }
        },
    pt:
        {
            translation:
            {
                Start: 'Comece a revolução',
                welcome: 'Olá, seja muito bem-vindo',
                Home: 'Início',
                description: "Bem-vindo à ACME AI — uma empresa visionária especializada em automação de negócios utilizando inteligência artificial e plataformas que a potencializam. Ajudamos pequenos negócios a destravar seu potencial de crescimento com soluções inteligentes, escaláveis e acessíveis. Seja para otimizar processos, integrar sistemas ou eliminar tarefas repetitivas, nossa expertise transforma complexidade em oportunidade.",
                Skills: 'O que fazemos pra você',
                SkillsTitle: 'Automação Inteligente. Crescimento Estratégico.',
                heroDescription: "Ajudamos empresas a simplificar operações, eliminar ineficiências e desbloquear crescimento escalável por meio de sistemas inteligentes.",
                Projects: 'Projetos',
                ProjectsTitle: 'Meus Projetos',
                whyTitle: "Por que escolher a gente",
                why1: "Nós focamos em resultados de negócios, não apenas em código.",
                why2: "Nós construímos soluções escaláveis, não apenas soluções temporárias.",
                why3: "Nós combinamos execução técnica com pensamento estratégico.",
                why4: "Nós trabalhamos como parceiros, não apenas como prestadores de serviço.",
                resultsTitle: "Resultados Que Entregamos",
                result1: "Eficiência operacional aumentada",
                result2: "Custos de processo reduzidos",
                result3: "Experiência do cliente melhorada",
                result4: "Infraestrutura digital escalável",
                processTitle: "Nosso Processo",
                process1Title: "Descoberta",
                process1Desc: "Entendemos seu negócio, desafios e oportunidades.",
                process2Title: "Estratégia",
                process2Desc: "Desenhamos a solução mais eficaz e escalável.",
                process3Title: "Execução",
                process3Desc: "Construímos, testamos e implementamos.",
                process4Title: "Otimização",
                process4Desc: "Refinamos e melhoramos continuamente.",
                ctaTitle: "Vamos Construir Juntos",
                ctaDesc: "Pronto para transformar seu negócio com automação inteligente e sistemas inteligentes?",
                ctaButton: "Iniciar uma Conversa",
                ProjectsButton: 'Ver Projeto',
                Contact: 'Contato',
                Name: 'Nome',
                Message: 'Mensagem',
                Send: 'Enviar',
                MessageSentSuccess: "Mensagem enviada com sucesso!",
                MessageSentFailure: "Erro ao enviar a mensagem. Tente novamente.",
                PrivacyPolicy: 'Política de Privacidade',
                TermsOfUse: 'Termos de Uso',
            }
        },
    fr:
        {
            translation:
            {
                Start: 'Déclenchez la révolution digitale',
                welcome: 'Salut, soyez le bienvenu',
                Home: 'Accueil',
                description: "Bienvenue chez ACME AI — une entreprise visionnaire spécialisée dans l'automatisation des entreprises grâce à l'intelligence artificielle et aux plateformes qui la renforcent. Nous aidons les petites entreprises à libérer leur potentiel de croissance grâce à des solutions intelligentes, évolutives et accessibles. Qu'il s'agisse d'optimiser les processus, d'intégrer des systèmes ou d'éliminer les tâches répétitives, notre expertise transforme la complexité en opportunité.",
                Skills: 'Ce que nous faisons pour vous',
                SkillsTitle: 'Autonomie intelligente. Croissance stratégique.',
                heroDescription: "Nous aidons les entreprises à simplifier les opérations, éliminer les inefficacités et débloquer une croissance évolutive grâce à des systèmes intelligents.",
                Projects: 'Projets',
                ProjectsTitle: 'Mes projets',
                whyTitle: "Pourquoi nous choisir",
                why1: "Nous nous concentrons sur les résultats commerciaux, pas seulement sur le code.",
                why2: "Nous construisons des solutions évolutives, pas des solutions temporaires.",
                why3: "Nous combinons l'exécution technique avec la réflexion stratégique.",
                why4: "Nous travaillons en tant que partenaires, pas seulement en tant que prestataires de services.",
                resultsTitle: "Résultats que nous livrons",
                result1: "Efficacité opérationnelle accrue",
                result2: "Coûts de processus réduits",
                result3: "Amélioration de l'expérience client",
                result4: "Infrastructure numérique évolutive",
                processTitle: "Notre processus",
                process1Title: "Découverte",
                process1Desc: "Nous comprenons votre entreprise, vos défis et vos opportunités.",
                process2Title: "Stratégie",
                process2Desc: "Nous concevons la solution la plus efficace et évolutive.",
                process3Title: "Exécution",
                process3Desc: "Nous construisons, testons et mettons en œuvre.",
                process4Title: "Optimisation",
                process4Desc: "Nous affinons et améliorons continuellement.",
                ctaTitle: "Construisons ensemble",
                ctaDesc: "Prêt à transformer votre entreprise avec une automatisation intelligente et des systèmes intelligents?",
                ctaButton: "Démarrer une conversation",
                ProjectsButton: 'Voir le projet',
                cardtitle1: 'Système de gestion de bibliothèque',
                Contact: 'Contact',
                Name: 'Nom',
                Message: 'Message',
                Send: 'Envoyer',
                MessageSentSuccess: "Message envoyé avec succès!",
                MessageSentFailure: "Erreur lors de l'envoi du message. Réessayer.",
                PrivacyPolicy: 'Politique de Confidentialité',
                TermsOfUse: 'Conditions d\'Utilisation',
            }
        },
    es:
        {
            translation:
            {
                Start: 'Despierta el futuro',
                welcome: 'Hola, sé muy bienvenido',
                Home: 'Inicio',
                description: "Bienvenido a ACME AI — una empresa visionaria especializada en la automatización de negocios mediante inteligencia artificial y plataformas que la potencian. Ayudamos a pequeñas empresas a desbloquear su potencial de crecimiento con soluciones inteligentes, escalables y accesibles. Ya sea optimizando procesos, integrando sistemas o eliminando tareas repetitivas, nuestra experiencia transforma la complejidad en oportunidad.",
                Skills: 'Lo que hacemos por ti',
                SkillsTitle: 'Automatización inteligente. Crecimiento estratégico.',
                heroDescription: "Ayudamos a las empresas a simplificar operaciones, eliminar ineficiencias y desbloquear un crecimiento escalable a través de sistemas inteligentes.",
                Projects: 'Proyectos',
                ProjectsTitle: 'Mis proyectos',
                whyTitle: "Por qué elegirnos",
                why1: "Nos enfocamos en resultados comerciales, no solo en código.",
                why2: "Construimos soluciones escalables, no solo soluciones temporales.",
                why3: "Combinamos ejecución técnica con reflexión estratégica.",
                why4: "Trabajamos como socios, no solo como proveedores de servicios.",
                resultsTitle: "Resultados que entregamos",
                result1: "Mayor eficiencia operativa",
                result2: "Reducción de costos de procesos",
                result3: "Mejora de la experiencia del cliente",
                result4: "Infraestructura digital escalable",
                processTitle: "Nuestro proceso",
                process1Title: "Descubrimiento",
                process1Desc: "Entendemos tu empresa, tus desafíos y tus oportunidades.",
                process2Title: "Estrategia",
                process2Desc: "Diseñamos la solución más eficiente y escalable.",
                process3Title: "Ejecución",
                process3Desc: "Construimos, probamos e implementamos.",
                process4Title: "Optimización",
                process4Desc: "Refinamos y mejoramos continuamente.",
                ctaTitle: "Construyamos juntos",
                ctaDesc: "¿Listo para transformar tu empresa con automatización inteligente y sistemas inteligentes?",
                ctaButton: "Iniciar una conversación",
                ProjectsButton: 'Ver Proyecto',
                Contact: 'Contacto',
                Name: 'Nombre',
                Message: 'Mensaje',
                Send: 'Enviar',
                MessageSentSuccess: "¡Mensaje enviado con éxito!",
                MessageSentFailure: "Error al enviar el mensaje. Inténtalo de nuevo.",
                PrivacyPolicy: 'Política de Privacidad',
                TermsOfUse: 'Términos de Uso',
            }
        }
};

i18n
.use(initReactI18next)
.init(
    {
        resources,
        lng: 'en',
        fallbackLng: 'en',
        keySeparator: false,
        interpolation:
        {
            escapeValue: false
        }
    }
);

export default i18n;